// web多语言key对应的oneHikId多语言key,只列了有区别的
export const WEB2ONEHIK_LANGUAGE_KEY = {
  in: 'id',
  zh_TW: 'zh_Hant'
};
